export default class ClearSelectedKbItem {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.selectedKbItem.set(null);
  }
}
